require('./_wks-define')('observable');


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/es7.symbol.observable.js
 ** module id = 237
 ** module chunks = 1
 **/